export default __webpack_public_path__ + "static/media/Preference.a79e00a6.jpg";